"use client";

import React from "react";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";
import { containerVariants, itemVariants } from "@/utils/animations";

export default function CareersPage() {
  return (
    <main className="font-sans text-midnight_text dark:text-white bg-white dark:bg-darkmode min-h-screen transition-colors duration-300 overflow-hidden flex flex-col">
      {/* --- Main Section --- */}
      <section className="relative flex-grow flex items-center justify-center py-32 px-6 bg-hero dark:bg-midnight">
        {/* Standard Project Background Blobs */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 right-0 w-[30rem] h-[30rem] bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-[40rem] h-[40rem] bg-blue-500/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />
        </div>

        <div className="max-w-[83.75rem] mx-auto w-full relative z-10">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="text-center max-w-3xl mx-auto"
          >
            {/* 1. Standard Header Block */}
            <motion.div variants={itemVariants} className="mb-12">
              <h1 className="text-48 md:text-6xl font-bold mb-6 leading-tight">
                Join Our <span className="text-primary">Journey</span>
              </h1>
              <p className="text-lg text-muted dark:text-white/70 leading-relaxed max-w-xl mx-auto">
                We are meticulously building our team to tackle industrial
                challenges. Here is our current hiring status.
              </p>
            </motion.div>

            {/* 2. The Roadmap Visualization (Clean, structured UI) */}
            <motion.div
              variants={itemVariants}
              className="relative max-w-lg mx-auto text-left py-10"
            >
              {/* Vertical connecting line */}
              <div className="absolute left-8 top-4 bottom-4 w-0.5 bg-gradient-to-b from-primary via-primary/50 to-muted/20 z-0"></div>

              {/* Milestone 1: CURRENT STATE (Active/Primary Color) */}
              <div className="relative z-10 flex items-start gap-8 mb-16">
                <div className="w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center shadow-lg shadow-primary/30 shrink-0 border-4 border-white dark:border-darkmode">
                  <Icon icon="ion:checkmark-sharp" className="text-3xl" />
                </div>
                <div className="pt-2">
                  <h3 className="text-xl font-bold text-midnight_text dark:text-white mb-2">
                    Foundational Team Established
                  </h3>
                  <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold uppercase rounded-full mb-4">
                    Current Status: Fully Staffed
                  </div>
                  <p className="text-muted dark:text-white/70 leading-relaxed">
                    We have successfully filled all key engineering and
                    operational roles for our current phase.
                  </p>
                </div>
              </div>

              {/* Milestone 2: FUTURE STATE (Muted/Upcoming Color) */}
              <div className="relative z-10 flex items-start gap-8 opacity-70">
                <div className="w-16 h-16 rounded-full bg-white dark:bg-white/5 border-2 border-dashed border-muted dark:border-white/30 text-muted dark:text-white/50 flex items-center justify-center shrink-0">
                  <Icon icon="ion:trending-up" className="text-3xl" />
                </div>
                <div className="pt-2">
                  <h3 className="text-xl font-bold text-muted dark:text-white/60 mb-2">
                    Next Growth Phase
                  </h3>
                  <div className="inline-block px-3 py-1 bg-muted/10 text-muted dark:text-white/50 text-xs font-bold uppercase rounded-full mb-4">
                    Upcoming
                  </div>
                  <p className="text-muted dark:text-white/60 leading-relaxed">
                    New opportunities in industrial innovation will be posted
                    here as we expand our operations.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* 3. Simple Footer Note */}
            <motion.div
              variants={itemVariants}
              className="mt-16 pt-8 border-t border-border dark:border-white/10 inline-block px-12"
            >
              <p className="text-base text-muted dark:text-white/70 font-medium">
                Thank you for your interest. Please check back periodically.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
